import { publicApi } from 'services/api';
import { MobileSettings } from 'types/entities/MobileSettings';

export const mobileSettingsApi = publicApi.injectEndpoints({
  endpoints: builder => ({
    getMobileSettings: builder.query<MobileSettings, void>({
      query: () => ({
        url: `/api/mobile/settings`,
        method: 'GET',
      }),
      providesTags: ['Mobile Settings'],
    }),
  }),
  overrideExisting: true,
});
